export const CONTACT_INFO = {
  email: 'estamosaqui@pasameunlink.com',
  phone: '+593 99 771 7151',
  phoneE164: '+593997717151',
  whatsapp: '593997717151',
  tagline: 'Creamos campañas que marcan y eventos excepcionales que dejan una huella imborrable.',
  ctaPhrase: 'Empecemos a trabajar juntos',
  locations: [
    { city: 'Cumbayá - Quito', country: 'Ecuador' },
    { city: 'Samborondón - Guayaquil', country: 'Ecuador' },
  ],
};

export const SOCIAL_LINKS = [
  { name: 'LinkedIn', handle: '/company/consultores-de-mercadeo-link', url: 'https://www.linkedin.com/company/consultores-de-mercadeo-link', icon: '/assets/icons/linkedin.png' },
  { name: 'Instagram', handle: '@linkconsultoresec', url: 'https://instagram.com/linkconsultoresec', icon: '/assets/icons/instagram.png' },
  { name: 'Facebook', handle: '/linkconsultoresec', url: 'https://facebook.com/linkconsultoresec', icon: '/assets/icons/facebook.png' },
  { name: 'TikTok', handle: '@link.ec', url: 'https://tiktok.com/@link.ec', icon: '/assets/icons/tiktok.png' },
  { name: 'WhatsApp', handle: '+593 99 771 7151', url: 'https://wa.me/593997717151', icon: '/assets/icons/whatsapp.png' },
];

export const NAV_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'Nosotros', href: '/nosotros' },
  { label: 'Servicios/Proyectos', href: '/servicios-proyectos' },
  { label: 'Contacto', href: '/contacto' },
];
